module.exports = __webpack_public_path__ + "static/img/mainicon.fd408245.png";